import { NodeResults } from "@custom-types/modelRun"
import { GraphDataViewModel } from "@features/graph/graphViewModel"
import { checkDataType } from "@features/results/Result/const"

export const getUnitFormats = (nodeLabels: string[]): Map<string, string> => {
  const formats = new Map()
  nodeLabels.forEach((item) => {
    let format = ""
    if (GraphDataViewModel.data) {
      const node = Object.values(GraphDataViewModel.data.nodeMap).find(
        (value) => value.display.label === item,
      )
      if (node) {
        format = node.display?.["Unit Format"] || ""
      }
    }
    formats.set(item, format)
  })

  return formats
}

export const getResultsTimesteps = (results: NodeResults, lag: number) => {
  const nodeRunResults = Object.values(results)
  const uniqueTimesteps: Set<number> = new Set()

  nodeRunResults.forEach((data) => {
    data.forEach((el, index) => {
      if (index >= lag) uniqueTimesteps.add(el.timestep)
    })
  })

  return Array.from(uniqueTimesteps)
}

export const getResultsDataType = (results: NodeResults) => {
  const nodeRunResults = Object.values(results)
  if (nodeRunResults.length === 0) return "undefined"

  let dataType = checkDataType(nodeRunResults[0])

  nodeRunResults.forEach((data) => {
    if (dataType !== checkDataType(data)) dataType = "undefined"
  })

  return dataType
}
